import * as api from '../api'
import { FETCH_ALL_TEAM, CREATE_TEAM, DELETE_TEAM, UPDATE_TEAM } from '../constants/actionTypes.js'
import { contrainteNotification, deleteContrainteNotification } from './notifications.js'

const JSON_ARRAY_FIELDS = new Set(['competitionsGroup']);

const appendTeamFormData = (formData, team) => {
  Object.keys(team).forEach((key) => {
    const value = team[key];

    if (value == null) {
      formData.append(key, '');
      return;
    }

    if (value instanceof File || value instanceof Blob) {
      formData.append(key, value);
      return;
    }

    if (JSON_ARRAY_FIELDS.has(key)) {
      formData.append(key, JSON.stringify(value || []));
      return;
    }

    // Ancien comportement conservé pour competitions, competitionsPenality, etc.
    if (Array.isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        const item = value[i];

        if (typeof item === 'string') {
          formData.append(`${key}[]`, item);
        } else {
          formData.append(`${key}[]`, JSON.stringify(item));
        }
      }
      return;
    }

    formData.append(key, value);
  });
};

// Action creator
export const getTeams = () => async (dispatch) => {

    try{
        const {data} = await api.fetchTeams()

        dispatch({ type: FETCH_ALL_TEAM, payload: data})

    } catch(error){
        console.log(error.message)
    } 
}

export const getTeamById = (id) => async (dispatch) => {

    try{
        const {data} = await api.fetchTeamById(id)

        dispatch({ type: FETCH_ALL_TEAM, payload: data})

    } catch(error){
        console.log(error.message)
    } 
}

export const createTeam = (team) => async (dispatch) => {
    try {
        const formData = new FormData()
        appendTeamFormData(formData, team);
        // Object.keys(team).map(key => {
        //     if(team[key] instanceof Array ){
        //         for (var i = 0; i < team[key].length; i++) {
        //             const value = team[key][i];
        //             if (typeof value === 'string') {
        //             formData.append(`${key}[]`, value);
        //             } else {
        //                 formData.append(`${key}[]`, JSON.stringify(value));
        //             }
        //         }
        //     }else{
        //         let noNull = team[key] ?? ""
        //         formData.append(key, noNull)
        //     }
        // })
        const { data } = await api.createTeam(formData)

        dispatch( { type : CREATE_TEAM, payload: data})
    } catch(error){
        console.log(error.message)
    }
}

export const updateTeam = (id, team) => async (dispatch) => {
    try {
        const formData = new FormData()
        appendTeamFormData(formData, team);
        // Object.keys(team).map(key => {
        //     if(team[key] instanceof Array ){
        //         for (var i = 0; i < team[key].length; i++) {
        //             const value = team[key][i];
        //             if (typeof value === 'string') {
        //             formData.append(`${key}[]`, value);
        //             } else {
        //                 formData.append(`${key}[]`, JSON.stringify(value));
        //             }
        //         }
        //     }else{
        //         let noNull = team[key] ?? ""
        //         formData.append(key, noNull)
        //     }
        // })
        
        const { data } = await api.updateTeam(id, formData)

        dispatch({ type : UPDATE_TEAM, payload: data})
    } catch(error){
        console.log(error.message)
    }
}

export const deleteTeam = (id, callback) => async (dispatch) => {
    try {
        await api.deleteTeam(id)

        dispatch(deleteContrainteNotification(id))

        callback(id)

        dispatch({ type : DELETE_TEAM, payload: id})
    }catch(error){
        const {error : serverError} = error.response?.data

        const {statusCode, type, typeObject, idObject} = serverError

        if(statusCode===409 && type==='constraint'){
            // Un autre object doit etre supprimé avant
            dispatch(contrainteNotification(idObject, typeObject))
        }
    }
}